import { ActionType, HomeState } from '../../schemas/Home/Home.schema';
import * as Constants from '../../utils/constants';
import produce from 'immer';

export const initalHomeState: HomeState = {
  watched: {
    data: [],
    totalRecords: 0,
    loaded: false,
    filter: {
      selected: [],
      direction: 'asc'
    }
  },

  apiErrorMessage: '',
  showMemberAPIError: false,
  recommended: {
    totalRecords: 0,
    loaded: false,
    data: [],
    message: '',
    status: false,
    resultId:'',
    filter: {
      selected: [],
      direction: 'asc'
    }
  },
  recommendedApiError: false,
  topRecommendationData: []
};

export default (state = initalHomeState, action: ActionType) =>
  produce(state, draft => {
    switch (action.type) {
      case Constants.WATCHEDLOAD_DATA_REQUEST:
        draft.watched.loaded = true;
        break;
      case Constants.WATCHEDLOAD_DATA_SUCCESS:
        const payload = action.payload && (action.payload as any);
        let items =
          (payload &&
            payload.watchedResults &&
            payload.watchedResults.data &&
            payload.watchedResults.data.getUserWatchedLoads &&
            payload.watchedResults.data.getUserWatchedLoads.loadPostings) ||
          [];
        const totalRecords =
          (payload &&
            payload.watchedResults &&
            payload.watchedResults.data &&
            payload.watchedResults.data.getUserWatchedLoads &&
            payload.watchedResults.data.getUserWatchedLoads.totalRecords) ||
          0;
        items = payload.refreshStatus
          ? items
          : [...draft.watched.data, ...items];
        draft.watched.data = items;
        draft.watched.loaded = true;
        draft.watched.totalRecords = totalRecords;
        break;
      case Constants.ADD_WATCH_LOAD_SUCCESS:
        const data = [...draft.watched.data, action.payload];
        draft.watched.data = data;
        draft.watched.totalRecords = draft.watched.totalRecords + 1;
        break;
      case Constants.REMOVE_WATCH_LOAD_SUCCESS:
        draft.watched.data = draft.watched.data.filter(
          details => details.loadId !== (action.payload as any).loadId
        );
        draft.watched.totalRecords = draft.watched.totalRecords - 1;
        break;
      case Constants.WATCHED_LOAD_FILTER:
        draft.watched.filter = (action.payload as any).filter;
        break;
      case Constants.RECOMMENDED_LOAD_FILTER:
        draft.recommended.filter = (action.payload as any).filter;
        break;
      case Constants.SHOW_API_RESPONSE_ERROR:
        draft.apiErrorMessage = (action.payload as any).message;
        break;
      case Constants.CLEAR_API_RESPONSE_ERROR:
        draft.apiErrorMessage = '';
        break;
      case Constants.TOP_RECOMMENDED_LOADS_SUCCESS:
        const recommpayload = action.payload && (action.payload as any);
        draft.topRecommendationData = recommpayload || [];
        break;
      case Constants.RECOMMENDED_LOADS_SUCCESS:
        const recpayload = action.payload && (action.payload as any);
        const recitems = getValues('loadPostings',recpayload) || [];
        const message = getValues('message',recpayload) || '';
        const status = getValues('status',recpayload) || false;
        const resultId = getValues('resultID',recpayload) || "";
        draft.recommended.data = recpayload.refreshStatus
          ? recitems
          : [...draft.recommended.data, ...recitems];
        draft.recommended.totalRecords = recitems && recitems.length || 0;
        draft.recommended.loaded = true;
        draft.recommended.message = message;
        draft.recommended.status = status;
        draft.recommended.resultId = resultId;
        break;
      case Constants.REMOVE_RECOMMENDEDRESULTS:
        const removedLoad = action.payload && (action.payload as any);
        draft.recommended.data = draft.recommended.data.filter(
          (details: any) => details.loadId !== removedLoad.loadId
        );
        draft.recommended.totalRecords = draft.recommended.totalRecords - 1;
        break;
      case Constants.SIMILAR_LOADS_SUCCESS:
        const response:any = action.payload && (action.payload as any);
        const simiMessage = response.similarResults.data.recommendedSimilarLoadsByLoadIds.message || '';
        const simiStatus = response.similarResults.data.recommendedSimilarLoadsByLoadIds.status || false;
        const enrichLoad = draft.recommended.data.map(
          (details: any) => {
            if (details.loadId == response.primaryLoadId) {
              let similarLoads = response.similarResults.data.recommendedSimilarLoadsByLoadIds.loadPostings;
              if (similarLoads && similarLoads.length) {
                details.similarLoads = similarLoads;
              }
              return details;
            } else {return details}
          }
        );
        draft.recommended.data = enrichLoad;
        if (!simiStatus) {
          draft.apiErrorMessage = simiMessage;
        }
        break;
        case Constants.AVAILABLE_LOADS_SUCCESS:
          const resp:any = action.payload && (action.payload as any);
          const avlMessage = resp.availableLoadResults.data.nextPickUpAvlFromDestStop.message || '';
          const avlStatus = resp.availableLoadResults.data.nextPickUpAvlFromDestStop.status || false;
          const enrichShipment = draft.recommended.data.map(
            (details: any) => {
              if (details.loadId == resp.loadId) {
                details.isNextPickupLoadAvailable = resp.availableLoadResults.data ? resp.availableLoadResults.data.nextPickUpAvlFromDestStop.isNextPickupLoadAvailable : false;
                details.nextPickupLoadAvlSearchCriteria = resp.availableLoadResults.data ? resp.availableLoadResults.data.nextPickUpAvlFromDestStop.nextPickupLoadAvlSearchCriteria : {};
                return details;
              } else {
                const hasSimilarLoads = typeof details.similarLoads[0] === "object";
                let isLoadUpdated = false;
                const enrichedSimilarLoads = hasSimilarLoads ? details.similarLoads.map(
                  (similarLoad: any) => {
                    if (similarLoad.loadId == resp.loadId) {
                      similarLoad.isNextPickupLoadAvailable = resp.availableLoadResults.data ? resp.availableLoadResults.data.nextPickUpAvlFromDestStop.isNextPickupLoadAvailable : false;
                      similarLoad.nextPickupLoadAvlSearchCriteria = resp.availableLoadResults.data ? resp.availableLoadResults.data.nextPickUpAvlFromDestStop.nextPickupLoadAvlSearchCriteria : {};
                      isLoadUpdated = true;
                      return similarLoad;
                    } else {return similarLoad}
                  }):null;
                  if(enrichedSimilarLoads && isLoadUpdated){
                    details.similarLoads = enrichedSimilarLoads;
                  }
                  return details;
              }
            }
          );
          draft.recommended.data = enrichShipment;
        if (!avlStatus) {
          draft.apiErrorMessage = avlMessage;
        }
        break;
      case Constants.SHOW_MEMBER_API_ERROR:
        draft.showMemberAPIError = action.payload && (action.payload as any);
        break;
      case Constants.SET_RECOMMENDED_API_ERROR:
        draft.recommendedApiError = action.payload && (action.payload as any);
        break;
    }
  });

const getValues = (key: string, recpayload: any) => {
  return (recpayload &&
    recpayload.recommendedResults &&
    recpayload.recommendedResults.data &&
    recpayload.recommendedResults.data.recommendedLoads &&
    recpayload.recommendedResults.data.recommendedLoads[key])
}
